// A dev design switch: ?<param>=N picks a variant and persists it in localStorage;
// otherwise the stored choice, otherwise the default. Renderers ask for these every
// frame (and per token / per head), so the answer is memoized and only re-read when
// the URL's query string changes: a fresh URLSearchParams + localStorage read per
// call showed up as a measurable slice of the client's per-frame JS.
const memo = new Map<string, { search: string; value: number }>();

export function readVariantParam(param: string, storageKey: string, ok: (s: string | null) => boolean, fallback: number): number {
  let search = "";
  try { search = window.location.search; } catch { /* no window */ }
  const hit = memo.get(param);
  if (hit && hit.search === search) return hit.value;
  let value = fallback;
  try {
    const q = new URLSearchParams(search).get(param);
    if (ok(q)) { localStorage.setItem(storageKey, q as string); value = +(q as string); }
    else {
      const s = localStorage.getItem(storageKey);
      if (ok(s)) value = +(s as string);
    }
  } catch { /* no storage */ }
  memo.set(param, { search, value });
  return value;
}
